import { translate } from '../services/TranslationService';

export function useTranslation(): { t: typeof translate } {
    return { t: translate };
}
